// White mark on a transparent background — needs a dark badge behind it (see
// DARK_BADGE_MAKERS in ModelLogo.jsx), unlike the other logos here.
export default function BlackForestLogo() {
  return <img src="/logos/black-forest-logo.png" alt="Black Forest Labs" width="16" height="16" className="block" />
}
